/* =============================================================================
   Velmora custom JS
   Added 8 September 2026. Both fixes below were diagnosed and approved on
   29 August but could not be saved at the time, because Shopify's raw code
   editor demands account-password verification. Writing to a draft theme
   through the Admin API avoids that checkpoint entirely.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------------------------------------------------------------------------
     FIX 1 - Homepage featured-product gallery renders solid black on first load.

     Root cause: lazysizes fires its "lazyloaded" event once the product photo
     finishes downloading, but the enclosing Slick carousel is never told to
     recalculate that slide, so it keeps painting its dark placeholder until
     something else (a click on a thumbnail) forces Slick to recompute.
     This is a sitewide pattern, not specific to one section.
     ------------------------------------------------------------------------ */
  document.addEventListener('lazyloaded', function (event) {
    var target = event && event.target;
    if (!target || typeof target.closest !== 'function') return;

    var slider = target.closest('.slick-slider');
    if (!slider) return;

    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return;

    try {
      $(slider).slick('setPosition');
    } catch (err) {
      /* Slider not initialised yet - nothing to repaint. */
    }
  });

  /* ---------------------------------------------------------------------------
     FIX 2 - Newsletter "Thanks for subscribing!" popup will not close.

     Root cause: this popup's close button has zero click handlers bound to it
     anywhere in the theme. Every other popup in this theme family has its own
     data-close-<name> attribute wired to a handler; this one was simply never
     wired up. A delegated listener is used so it works no matter when the
     modal is injected into the page.

     There is also a CSS auto-dismiss in Theme settings that fades the popup
     out after about five seconds. That stays as a backstop; this makes the
     X button itself actually work.
     ------------------------------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var target = event && event.target;
    if (!target || typeof target.closest !== 'function') return;

    var button = target.closest(
      '#newsletter-success-modal .close-modal, #newsletter-success-modal .close'
    );
    if (!button) return;

    var modal = document.getElementById('newsletter-success-modal');
    if (!modal) return;

    event.preventDefault();

    modal.style.opacity = '0';
    modal.style.visibility = 'hidden';
    modal.style.pointerEvents = 'none';
    modal.classList.remove('is-open', 'open', 'active');

    document.body.classList.remove('halo-popup-open', 'popup-open', 'modal-open');
  });
})();
